import { fullComparator } from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getRevenusChargesBuilders(): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'REVENUS_CHARGES',
      'REVENU_TOTAL_EFFECTIF',
      'bilanFinancier.effectiveRevenus',
      fullComparator,
      'InputEuro',
      undefined
    ),
    new ItemFiltreCustomBuilder(
      'REVENUS_CHARGES',
      'CHARGES_TOTAL_EFFECTIF',
      'bilanFinancier.effectiveCharges',
      fullComparator,
      'InputEuro',
      undefined
    ),
  ];
}
